import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

export default function CheckboxesGroup(props) {

  const { handleSelect, control, defaultNames, checkedValues, handleSubmit, DataDtls, ...others } = props;

  return (
    <form onSubmit={handleSubmit(e => console.log(e))}>
      {DataDtls.map(dtls => (
        <FormControlLabel
          control={
            <Controller
              as={<Checkbox />}
              control={control}
              checked={checkedValues.includes(dtls.label)}
              name="names"
              onChange={() => handleSelect(dtls.label)}
            />
          }
          key={dtls.label}
          label={dtls.label}
        />
      ))}
    </form>
  );
}
